((Drupal, drupalSettings) => {
  Drupal.behaviors.hbnFilteredView = {
    attach(context) {
      const pageOject =
        context.nodeType === 9 ? context.documentElement : context;
      once("hbn_filtered_view", pageOject, context).forEach((body) => {
        if (drupalSettings.hbn_filters !== undefined) {
          drupalSettings.hbn_filters.forEach((filter) => {
            const form = document.querySelector(`#${filter}`);
            if (form) {
              form.querySelector("details").setAttribute("open", "open");
            }
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
